import toast from "react-hot-toast";
import { showErrors } from "../utils/errors";
import { capitalizer } from "../utils/string";
import * as TYPES from "./constants";

export default function OrderReducer(
  state: any = {
    isLoading: false,
    sideLoading: false,
    orders: [],
    order: {},
    detail: "",
    loadMore: false,
    end: false,
    updating: false,
    history: [],
  },
  action
) {
  switch (action.type) {
    case TYPES.GET_ORDERS:
      return {
        ...state,
        isLoading: true,
      };
    case TYPES.LOAD_MORE:
      return {
        ...state,
        loadMore: true,
      };
    case TYPES.GET_SINGLE_ORDER:
      return {
        ...state,
        sideLoading: true,
      };
    case TYPES.LIST_ORDERS:
      return {
        ...state,
        orders: action.payload?.items,
        isLoading: false,
        page: action?.payload?.page,
        paginate: action?.payload?.paginate,
        total: action?.payload.total,
        end: false,
        pages: Math.round(action.payload.total / action.payload.paginate) + 1,
      };
    case TYPES.FETCH_MORE:
      return {
        ...state,
        orders: [...state.orders, ...action.payload?.items],
        isLoading: false,
        loadMore: false,
        end: action.payload?.items.length === 0 ? true : false,
        page: action?.payload?.page,
        paginate: action?.payload?.paginate,
        total: action?.payload.total,
        pages: Math.round(action.payload.total / action.payload.paginate) + 1,
      };
    case TYPES.LIST_ORDER:
      return {
        ...state,
        order: action.payload,
        sideLoading: false,
      };
    case TYPES.GET_STATUS:
      return {
        ...state,
        history: action.payload,
      };
    case TYPES.SYNC_ORDER:
      if (action.payload.order_status_id !== state.order.order_status_id) {
        toast(`Order update: ${capitalizer(action.payload.order_status_id)}`, {
          style: {
            borderRadius: "10px",
            background: "#333",
            color: "#fff",
          },
        });
      }

      if (action.payload.invoice_status_id !== state.order.invoice_status_id) {
        toast(
          `Payment update: ${capitalizer(action.payload.invoice_status_id)}`,
          {
            style: {
              borderRadius: "10px",
              background: "#333",
              color: "#fff",
            },
          }
        );
      }

      return {
        ...state,
        order: action.payload,
        sideLoading: false,
      };
    case TYPES.ORDER_ERROR:
    case TYPES.UPDATE_ERROR:
      showErrors(action.payload.errors, action.payload.detail);
      return {
        ...state,
        isLoading: false,
        sideLoading: false,
        detail: action.payload.detail,
        updating: false,
      };
    case TYPES.UPDATE:
      return {
        ...state,
        updating: true,
      };
    case TYPES.ORDER_STATUS_UPDATE:
      return {
        ...state,
        updating: false,
        isLoading: false,
        order: action.payload,
      };
    default:
      return state;
  }
}
